import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ShiftDataService } from '../shift-data-analysis/shift-data.service';
import { DashboardService } from 'app/services/dashboard.service';

@Component({
  selector: 'app-view-more-details',
  templateUrl: './view-more-details.component.html',
  styleUrls: ['./view-more-details.component.scss']
})
export class ViewMoreDetailsComponent implements OnInit {

  // assets:any[]=['Signboard Chevron Board','Kerbs','Kerbs','Kerbs','Signboard Chevron Board','Kerbs','Kerbs','Kerbs','Signboard Chevron Board','Kerbs','Kerbs','Kerbs'];
  windowName:string = '';
  btnText:string = '';
  confirmCall:boolean = false;
  displayExclusionDetails:any; 

  constructor(public dialogRef: MatDialogRef<ViewMoreDetailsComponent>,public shiftDataService:ShiftDataService,public dashboardService:DashboardService,
    @Inject(MAT_DIALOG_DATA) public data: any) {
    this.confirmCall = data && data.confirm;
    this.windowName = data && data.confirm ? 'Confirm These Details' : 'Exclusion Details';
    this.btnText =  data && data.confirm ? 'Save Exclusion' : 'OK';    
    if(data && data != null && data.confirm){
      this.displayExclusionDetails = data;
    }
    else{
      let selectedExclusionIndex :any = localStorage.getItem("selectedExclusionIndex");
      if(selectedExclusionIndex != undefined && selectedExclusionIndex != '' && selectedExclusionIndex != null){
        selectedExclusionIndex = parseInt(selectedExclusionIndex);
      }
      this.displayExclusionDetails = (this.shiftDataService && this.shiftDataService.siteTotalExclusions && this.shiftDataService.siteTotalExclusions[selectedExclusionIndex]) ?
      this.shiftDataService.siteTotalExclusions[selectedExclusionIndex] : '';
      this.displayExclusionDetails.periodFrom = this.displayExclusionDetails.periodFrom;
      this.displayExclusionDetails.periodTo = this.displayExclusionDetails.periodTo;
    }
  }

  ngOnInit(): void { }

  isChecked(asset: any) {
    return !!this.shiftDataService.selectedAssetIdsForExclusion.filter(
        (a) => a.asset_id == asset.asset_id
    ).length;
  }

  closeDialogBox(){
    this.dialogRef.close(false);
  }

  saveExclusion(){
    if(this.isSaveEnable() && this.btnText.toLowerCase() != 'OK'.toLowerCase()){
      this.dialogRef.close(true);
    }
  }

  checkAssets(asset:any){
    this.shiftDataService.selectedAssetIdsForExclusion =
        this.shiftDataService.selectedAssetIdsForExclusion.filter(
            (a) => +a.asset_id == +asset.asset_id
        ).length > 0
            ? this.shiftDataService.selectedAssetIdsForExclusion.filter(
                  (a) => +a.asset_id != +asset.asset_id
              )
            : [...this.shiftDataService.selectedAssetIdsForExclusion, asset];
  }

  isSaveEnable():boolean{
    if(this.shiftDataService.period_from != null && this.shiftDataService.period_from != undefined && this.shiftDataService.period_from != '' &&
      this.shiftDataService.period_to != null && this.shiftDataService.period_to != undefined && this.shiftDataService.period_to != '' &&
      this.shiftDataService.fromChainageValue != null && this.shiftDataService.fromChainageValue != undefined &&
      this.shiftDataService.toChainageValue != null && this.shiftDataService.toChainageValue != undefined &&
      this.shiftDataService.textInputValue != null && this.shiftDataService.textInputValue != undefined && this.shiftDataService.textInputValue != '' &&
      this.shiftDataService.selectedAssetIdsForExclusion.length > 0 
    ){
      return true;
    }
    return false;
  }

}
